import { Text } from '@chakra-ui/react';
import { TextBlockViewProps, BlockItemViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';

export function createDocumentTextView(
    config: ReportingViewBaseConfig & {
        BlockItem: React.FC<BlockItemViewProps>;
    }
): React.FC<TextBlockViewProps> {
    const { BlockItem } = config;

    return (props) => {
        return (
            <BlockItem {...props.block}>
                <Text color="whiteAlpha.700">{props.children}</Text>
            </BlockItem>
        );
    };
}
